import { Stack, Typography } from '@mui/material';
import { formatCurrency } from 'utils/validators/HelperFunctions';

type ActualizationTaxCellProps = {
  amount?: number | string | null;
  taxGroupName?: string | null;
};

/** Tax amount with the tax group (e.g. "GST 18%") underneath, used by every actualization table. */
export const ActualizationTaxCell = ({ amount, taxGroupName }: ActualizationTaxCellProps) => {
  const hasAmount = amount != null && amount !== '' && Number.isFinite(Number(amount));
  const groupName = taxGroupName && taxGroupName !== '—' ? taxGroupName : '';
  if (!hasAmount && !groupName) return <>—</>;
  return (
    <Stack alignItems="flex-end" spacing={0.125}>
      <Typography sx={{ fontSize: '12px', lineHeight: 1.25 }}>
        {hasAmount ? formatCurrency(Number(amount)) : '—'}
      </Typography>
      {groupName ? (
        <Typography color="text.secondary" sx={{ fontSize: '10px', lineHeight: 1.25 }}>
          {groupName}
        </Typography>
      ) : null}
    </Stack>
  );
};
